export type Units = string | number;

export function px(value: string | number): string {
    if ((_.isString(value) && !_.endsWith(value, 'px')) || _.isNumber(value)) {
        return value + 'px';
    }
    return value;
}

export function toNumber(unit: Units): number {
    return _.isNumber(unit) ? unit : parseFloat(unit);
}
